document.addEventListener('DOMContentLoaded', () => {
  if (window.isTradeAccount && !sessionStorage.getItem('tradeToastShown')) {
    showTradeToast();
    sessionStorage.setItem('tradeToastShown', 'true');
  }
});
function showTradeToast() {
  const toast = document.createElement('div');
  toast.className = 'trade-toast';
  toast.setAttribute('role', 'status');
  toast.innerHTML = `
    <div class="trade-toast__inner">
      <span class="trade-toast__text">You are now logging into a trade account</span>
      <button class="trade-toast__close" aria-label="Dismiss">&times;</button>
    </div>
  `;
  document.body.appendChild(toast);
  const dismiss = () => toast.remove();
  toast.querySelector('.trade-toast__close').addEventListener('click', dismiss);
  setTimeout(dismiss, 5000);
}